$.fn.Share = function() {
  let self = this

  if (self.data('share')) {
    return self.data('share')
  }

  self.copy_link = function() {
    self.find('.share__action--copy-link').width(self.find('.share__action--copy-link').width())
    self.find('textarea').val(window.location.href).focus().select()
    document.execCommand("Copy")
    self.find('.share__action--copy-link span').text(gourmetsauvage_params.COPIED_LINK).addClass('visible')
    setTimeout(function() {
      self.find('.share__action--copy-link span').removeClass('visible')
    }, 2000)
    return false
  }

  self.open = function() {
    // Close all other share buttons first
    $('.wishlist-share').not(self).each(function() {
      const instance = $(this).data('share')
      if (instance && instance.close) {
        instance.close()
      }
    })
    $(document).on('click', self.clicked_outside)
    self.attr('aria-expanded', 'true')
  }

  self.close = function() {
    $(document).off('click', self.clicked_outside)
    self.attr('aria-expanded', 'false')
  }

  self.toggle_expand = function() {
    if (self.attr('aria-expanded') && self.attr('aria-expanded') == 'false') {
      self.open()
    } else if (self.attr('aria-expanded') && self.attr('aria-expanded') == 'true') {
      self.close()
    }
  }

  self.clicked_outside = function(e) {
    if (!$(e.target).hasClass('.share') && !$(e.target).closest('.share').length) {
      self.close()
    }
  }

  return function() {
    self.find('.share-button').on('click', self.toggle_expand)
    self.find('.share__action--copy-link').on('click', self.copy_link)
    self.data('share', self)
    return self
  }()
}
